import { render } from "./SupplierList.vue?vue&type=template&id=ce397db0&scoped=true"
import script from "./SupplierList.vue?vue&type=script&lang=js"
export * from "./SupplierList.vue?vue&type=script&lang=js"

import "./SupplierList.vue?vue&type=style&index=0&id=ce397db0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce397db0"]])

export default __exports__